module.exports = __webpack_public_path__ + "static/media/mechanic-illustration.6379b22e.jpg";